<div class="inner-content" (click)="onContentClick()">
  <ion-button size="small" shape="round" (click)="close()">
    <ion-icon slot="icon-only" name="close"></ion-icon>
  </ion-button>
  <ng-container *ngComponentOutlet="component; inputs: componentInputs" />
</div>
